const initialData = {
  tasks: {
    'task-1': { id: 'task-1', content: `Choose a robot. Outrageously increase the cars' price. It will reach the first spot in the Top Clients chart.` },
    'task-2': { id: 'task-2', content: `Go to 'Requests' and accept Korie Antonoczyk's request for a Tesla Cybetruck.`},
    'task-3': { id: 'task-3', content: `Search for Korie Antonoczyk using the searchbar. Delete its Tesla.` },
    'task-4': { id: 'task-4', content: `Go to 'Dashboard' and move the boxes around.` },
    'task-5': { id: 'task-5', content: `Delete a robot. Accept its request. Look up 'New Clients'.` },
    'task-6': { id: 'task-6', content: `Testing DriveNY.` },
    'task-7': { id: 'task-7', content: `Developed DriveNY using JS, React 16.12, styled-components.` },
    'task-8': { id: 'task-8', content: `Data comes from a JSON file designed for DriveNY. The state is initialized with useReducer and the dispatch function is passed down via context.` },
  },
  columns: {
    'column-1': {
      id: 'column-1',
      title: 'To do',
      taskIds: ['task-1', 'task-2', 'task-3', 'task-4', 'task-5']
    },
    'column-2': {
      id: 'column-2',
      title: 'In progress',
      taskIds: ['task-6']
    },
    'column-3': {
      id: 'column-3',
      title: 'Done',
      taskIds: ['task-7', 'task-8']
    },
  },
  columnOrder: ['column-1','column-2','column-3']
}

export default initialData